const TamperTokenModel = {
  edit: false,
  table: "res_partner",
  control: "meter_action",
  fields: [
    // {
    //   name: "meter_no",
    //   type: "select_db_auto",
    //   sort: "meter_no",
    //   fullWidth: true,
    //   table: "meter_details",
    //   value: "meter_no",
    //   field: "concat(id,' - ', meter_no)",
    //   label: "Select Meter",
    //   picks: [],
    // },
    {
      name: "field",
      type: "hidden",
      value: "",
    },
    {
      name: "value",
      type: "hidden",
      value: "",
    },
    {
      name: "lifenotes",
      type: "text",
      validate: { required: true },
      fullWidth: true,
      label: "Reason",
    },
    {
      name: "action",
      type: "hidden",
      value: "tampertoken",
    },
  ],
  desc: "Tamper Token",
  title: "Tamper Token Setup",
};

export default TamperTokenModel;
